module.exports = __webpack_public_path__ + "static/screen-web-goals-e839354b7d89911f2fd233e1b49775ed.png";